module.exports = __webpack_public_path__ + "img/logo_Atlas.aa1ce882.svg";